import { z } from "zod";
import { SAV_SUITES } from "../../../../enums.js";

/** Bilan de la visite et suite à donner (rien, nouvelle venue, devis…). */
export const savConclusionSchema = z
  .object({
    resume: z.string(),
    suite: z.enum(SAV_SUITES),
    suiteDetail: z.string(),
  })
  .partial();

export type SavConclusion = z.infer<typeof savConclusionSchema>;
